import * as React from 'react';
import { TabsContext } from './SettingPopupTabs';

interface SettingPopupTabProps {
  index?: number;
  style?: React.CSSProperties;
  highlightStyle?: React.CSSProperties;
  selectedStyle?: React.CSSProperties;
  onClick?: (ev: React.MouseEvent) => void;
}

interface SettingPopupTabState {
  highlighted: boolean;
}

const fundamentalStyle: React.CSSProperties = {
  width: '48px',
  height: '48px',
  fontSize: '11px',
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  margin: '8px',
  border: '1px solid #000',
};

class SettingPopupTab extends React.PureComponent<SettingPopupTabProps, SettingPopupTabState> {
  public constructor(props: SettingPopupTabProps) {
    super(props);

    this.state = {
      highlighted: false,
    };
  }

  private handlePointerDown = () => {
    this.setState({ highlighted: true });
  }

  private handlePointerUp = () => {
    this.setState({ highlighted: false });
  }

  public render() {
    return (
      <TabsContext.Consumer>{(context) => {
        const { index, style, onClick, highlightStyle, selectedStyle } = this.props;

        const computedHighlightStyle: React.CSSProperties | null = this.state.highlighted
          ? highlightStyle || { backgroundColor: '#fff' }
          : null;

        const computedSelectedStyle: React.CSSProperties | null = context.selectedTabIndex === index
          ? selectedStyle || { outline: '4px solid #fff' }
          : null;

        return (
          <div
            style={{
              ...fundamentalStyle,
              ...style,
              ...computedHighlightStyle,
              ...computedSelectedStyle,
            }}
            onClick={(ev) => {
              if (onClick != null) {
                onClick(ev);
              }
              context.onClickTab(index || 0);
            }}
            onMouseDown={this.handlePointerDown}
            onTouchStart={this.handlePointerDown}
            onPointerDown={this.handlePointerDown}
            onMouseUp={this.handlePointerUp}
            onTouchEnd={this.handlePointerUp}
            onPointerUp={this.handlePointerUp}
            onMouseOut={this.handlePointerUp}
            onTouchCancel={this.handlePointerUp}
            onPointerCancel={this.handlePointerUp}
            onPointerOut={this.handlePointerUp} >
            {this.props.children}
          </div>
        );
      }}</TabsContext.Consumer>
    );
  }
}

export default SettingPopupTab;
